import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import { mapGetters } from "vuex";
import telematicsService from "../../../api/telematics.service";

export default {
  name: 'product-exclusions',
  components: { pageheader },
  data() {
    return {
      input: {},
      productId: "",
      deleteId:"",
      deleteProductId:"",
      description: "",
      loader:false,
      dialog:false,
      loadersave:false,
      isdelete:false,
      productExclusionsList: [],
      productheaders: [
        { text: "Product Id", value: "productKey"},
        { text: "Description", value: "description"},
        { text: "Action", value: "action" },
      ]
    }
  },
  computed: {
    ...mapGetters(["roles"])

  },
  mounted() {
    this.input = utils.getInputContent("productexclusion", this.roles);
    this.getproductexclusions();
  },
  methods: {
    async getproductexclusions() {
      try {
        this.loader = true;
        let product = await telematicsService.getproductexclusions();
        if (product.isSuccess) {
          this.productExclusionsList = product.data;
          this.loader = false;
        }
        else{
          this.loader = false;

        }
      } catch (err) {
        this.loader = false;

        console.log(err);
      }
    },
    async deleteproductexclusion() {
      try {
        this.isdelete = true;
      
        let delproductexclusion = await telematicsService.deleteproductexclusions(this.deleteId);
        if (delproductexclusion) {
          this.isdelete = false;
          this.$toast.success(delproductexclusion.systemMessage);
          this.getproductexclusions();
          this.dialog = false;
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete productexclusion" + err);
        this.dialog = false;
      }
    },
    async addproductExclusions(){
      try {
        this.loadersave = true;
        let payload = {
          productId: this.productId,
          description: this.description
        };
        let productsave = await telematicsService.addproductexclusions(payload);
        if (productsave) {
          this.loadersave = false;
          this.$toast.success(productsave.systemMessage);
          this.productId = "";
          this.description = "";
          this.getproductexclusions();
        }
      } catch (err) {
        this.loadersave = false;
        this.$toast.error("Unable to delete productexclusion" + err);
     
      }
    },
    confirmDelete(item) {
      this.deleteId = item.id;
      this.deleteProductId = item.productId;
      this.dialog = true;
    },
  }
}


